import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  Col,
  DatePicker,
  Dropdown,
  Form,
  Input,
  Row,
  Select,
  message,
} from "antd";
import TextArea from "antd/es/input/TextArea";
import "dayjs/plugin/utc";
import { CameraOutlined, FileOutlined, PlusOutlined } from "@ant-design/icons";
import profile from "../../../Assets/Images/Profile Avatar.png";
import { useForm } from "antd/es/form/Form";
import CommonFunctions from "../../Shared/CommonFunctions";
import PatientService from "../../../Services/PatientService";
import dayjs from "dayjs";
import StateMasterService from "../../../Services/StateMasterService";
import PatientRegistration from "../../../Assets/Images/Svg/patientregister.svg";

function NewPatientRegister({
  handleKeyPress,
  handleCancel,
  getPatientList,
  videoRef,
}) {
  const [form] = useForm();
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [profileImage, setProfileImage] = useState(null);
  const fileInputRef = useRef(null);
  const [photoValue, setPhotoValue] = useState(null);
  const [profileType, setProfileType] = useState(null);
  const [states, setStates] = useState([]);
  const [countries, setCountries] = useState([]);
  const [isCameraOpen, setIsCameraOpen] = useState(false);
  const canvasRef = useRef(null);

  const getStateList = () => {
    let payload = {
      status: 1,
    };
    StateMasterService.StateMaster(payload).then((res) => {
      setStates(res.data);
    });
    StateMasterService.CountryMaster(payload).then((res) => {
      setCountries(res.data);
    });
  };

  useEffect(() => {
    getStateList();
  }, []);

  const storedLoginResult = localStorage.getItem("login_result");
  const loginResultObject = storedLoginResult
    ? JSON.parse(storedLoginResult)
    : null;

  const patientCancel = () => {
    form.resetFields();
    handleCancel();
    setPhotoValue(null);
    setProfileType(null);
    setProfileImage(null);
  };

  const handleSubmit = (payload) => {
    setIsButtonDisabled(true);
    payload.account_Id = loginResultObject.user.account_Id;
    payload.clinic_Id = loginResultObject.user.clinic_Id;
    payload.createdBy = loginResultObject.user.userId;
    payload.modifiedBy = loginResultObject.user.userId;
    payload.photo = photoValue;
    payload.photoType = profileType;
    payload.status = 1;
    payload.dob = dayjs(payload.dob, "MM/DD/YYYY").format("MM/DD/YYYY");
    payload.createdDate = CommonFunctions.convertUTCDate(
      new Date(),
      "YYYY-MM-DD HH:mm:ss"
    );
    payload.modifiedDate = CommonFunctions.convertUTCDate(
      new Date(),
      "YYYY-MM-DD HH:mm:ss"
    );
    PatientService.PatientRegistration(payload)
      .then((result) => {
        if (result.data) {
          message.success("New Patient Registration successfull");
          form.resetFields();
          handleCancel();
          // getPatientList();
          setPhotoValue(null);
          setProfileType(null);
          setProfileImage(null);
        } else {
          message.error("Registration failed");
        }
      })
      .catch((error) => {
        console.error("An error occurred during registration:", error);
        message.error("This Email  or Mobile number is already registered");
      })
      .finally(() => {
        setIsButtonDisabled(false);
      });
  };

  const genders = [
    {
      value: "M",
      label: "Male",
    },
    {
      value: "F",
      label: "Female",
    },
  ];
  const bloodgroup = ["A+", "A-", "B+", "B-", "AB+", "AB-", "O+", "O-"];
  const maritalStatusOptions = [
    { label: "Married", value: "M" },
    { label: "Unmarried", value: "U" },
  ];
  const salutationOptions = [
    {
      value: "Mr.",
      label: "Mr.",
    },
    {
      value: "Mrs.",
      label: "Mrs.",
    },
    {
      value: "Miss.",
      label: "Miss.",
    },
    {
      value: "Ms.",
      label: "Ms.",
    },
  ];

  const handleFileSelect = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const validImageTypes = ["image/jpeg", "image/png", "image/jpg"];
      if (!validImageTypes.includes(file.type)) {
        message.error("Only image files (JPG, PNG, JPEG) are allowed!");
        return;
      }
      const reader = new FileReader();
      reader.onloadend = () => {
        let imageArray = reader.result.split(",");
        setProfileImage(reader.result);
        setPhotoValue(imageArray[1]);
        setProfileType(file.type.split("/")[1]);
      };
      reader.readAsDataURL(file);
    }
  };

  const disabledDate = (current) => {
    return current && current > new Date().setHours(23, 59, 59, 999);
  };

  const openCamera = async () => {
    setIsCameraOpen(true);
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ video: true });
      if (videoRef.current) {
        videoRef.current.srcObject = stream;
      }
    } catch (error) {
      console.error("Error accessing camera:", error);
      message.error("Please allow camera access in your browser settings.");
    }
  };

  const stopCamera = () => {
    if (videoRef.current && videoRef.current.srcObject) {
      const stream = videoRef.current.srcObject;
      const tracks = stream.getTracks();
      tracks.forEach((track) => track.stop());
      videoRef.current.srcObject = null;
    }
    setIsCameraOpen(false);
  };

  const capturePhoto = () => {
    const canvas = canvasRef.current;
    const video = videoRef.current;
    const context = canvas.getContext("2d");
    context.drawImage(video, 0, 0, canvas.width, canvas.height);
    const imageDataUrl = canvas.toDataURL("image/png");

    setProfileImage(imageDataUrl);
    setPhotoValue(imageDataUrl.split(",")[1]);
    setProfileType("png");

    stopCamera();
  };

  const uploadOptions = [
    {
      key: "1",
      label: (
        <Button
          className="text-white "
          type="text"
          icon={<FileOutlined />}
          onClick={handleFileSelect}
        >
          Choose File
        </Button>
      ),
    },
    {
      key: "2",
      label: (
        <Button
          className="text-white"
          type="text"
          icon={<CameraOutlined />}
          onClick={openCamera}
        >
          Take Picture
        </Button>
      ),
    },
  ];

  return (
    <>
      <Form
        className="formDesign patientForm mt-3"
        name="basic"
        layout="vertical"
        autoComplete="off"
        form={form}
        onFinish={handleSubmit}
        closeIcon={false}
      >
        <Row gutter={24} className=" border-2 rounded-md ">
          <div className="h-32 p-3 bg-[#F6FEFF] rounded-md w-full border-b">
            <div className="flex justify-between items-center">
              <div className="flex gap-6 relative">
                <Dropdown menu={{ items: uploadOptions }} trigger={["click"]}>
                  <div className="Upload h-20 w-20 border-2 border-dashed p-4 rounded-full cursor-pointer ">
                    <input
                      type="file"
                      accept="image/*"
                      style={{ display: "none" }}
                      onChange={handleFileChange}
                      ref={fileInputRef}
                    />
                    {profileImage ? (
                      <img
                        src={profileImage}
                        alt="Profile"
                        className="absolute top-0 left-0 w-full h-full object-cover rounded-full"
                      />
                    ) : (
                      <div className="absolute top-6 left-24 flex items-center">
                        <div className="bg-white border rounded-md h-7  w-28">
                          <span className="px-2 font-sans font-semibold">
                            Upload Profile
                          </span>
                        </div>
                      </div>
                    )}
                  </div>
                </Dropdown>
              </div>
              <img src={PatientRegistration} alt="img" />
            </div>
          </div>
          {isCameraOpen && (
            <div className="camera-container">
              <video ref={videoRef} autoPlay className="w-full h-48" />
              <canvas
                ref={canvasRef}
                width="200"
                height="200"
                style={{ display: "none" }}
              />
              <div className="flex justify-between">
                <Button type="primary" onClick={capturePhoto} className="mt-2">
                  Capture
                </Button>
                <Button
                  type="default"
                  onClick={stopCamera}
                  className="mt-2 text-white"
                >
                  Close
                </Button>
              </div>
            </div>
          )}

          <div className="p-3 ">
            <p className=" font-sans font-semibold">Personal Details</p>
            <Row gutter={20} className="mt-4">
              <Col xs={24} sm={12} md={8} lg={6} xl={6}>
                <Form.Item
                  // label={
                  //   <span>
                  //     Salutation
                  //     <span style={{ color: "#FF000F" }}> *</span>
                  //   </span>
                  // }
                  name="salutation"
                  rules={[
                    {
                      required: true,
                      message: "Please input salutation!",
                    },
                  ]}
                >
                  <Select
                    options={salutationOptions}
                    placeholder=" Salutation"
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} md={8} lg={6} xl={9}>
                <Form.Item
                  // label={
                  //   <span>
                  //     First Name
                  //     <span style={{ color: "#FF000F" }}> *</span>
                  //   </span>
                  // }
                  name="firstName"
                  rules={[
                    {
                      required: true,
                      message: "Please Enter First Name!",
                    },
                  ]}
                >
                  <Input className="w-full" placeholder=" First Name" />
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} md={8} lg={6} xl={9}>
                <Form.Item
                  // label={
                  //   <span>
                  //     Last Name
                  //     <span style={{ color: "#FF000F" }}> *</span>
                  //   </span>
                  // }
                  name="lastName"
                  rules={[
                    {
                      required: true,
                      message: "Please Enter Last Name!",
                    },
                  ]}
                >
                  <Input className="w-full" placeholder="Last Name" />
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} md={8} lg={6} xl={6}>
                <Form.Item
                  // label={
                  //   <span>
                  //     D.O.B
                  //     <span style={{ color: "#FF000F" }}> *</span>
                  //   </span>
                  // }
                  name="dob"
                  rules={[
                    {
                      required: true,
                      message: "Please Enter D.O.B!",
                    },
                  ]}
                >
                  <DatePicker
                    className="w-full"
                    format={"DD/MM/YYYY"}
                    disabledDate={disabledDate}
                    placeholder="D.O.B"
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} md={8} lg={6} xl={6}>
                <Form.Item
                  // label={
                  //   <span>
                  //     Gender
                  //     <span style={{ color: "#FF000F" }}> *</span>
                  //   </span>
                  // }
                  name="gender"
                  rules={[
                    {
                      required: true,
                      message: "Please Enter Gender!",
                    },
                  ]}
                >
                  <Select options={genders} placeholder="Gender" />
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} md={8} lg={6} xl={6}>
                <Form.Item
                  // label={
                  //   <span>
                  //     Blood Group
                  //     <span style={{ color: "#FF000F" }}> *</span>
                  //   </span>
                  // }
                  name="bloodGroup"
                  rules={[
                    {
                      required: true,
                      message: "Please Enter Blood Group!",
                    },
                  ]}
                >
                  <Select className="w-full" placeholder="Blood Group">
                    {bloodgroup.map((option) => (
                      <Select.Option key={option} value={option}>
                        {option}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} md={8} lg={6} xl={6}>
                <Form.Item
                  // label={<span>Marital Status</span>}
                  name="maritalStatus"
                >
                  <Select className="w-full" placeholder="Marital Status">
                    {maritalStatusOptions.map((option) => (
                      <Select.Option key={option.value} value={option.value}>
                        {option.label}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>

              <Col xs={24} sm={12} md={8} lg={6} xl={12}>
                <Form.Item
                  // label={
                  //   <span>
                  //     Mobile Number
                  //     <span style={{ color: "#FF000F" }}> *</span>
                  //   </span>
                  // }
                  name="mobile"
                  rules={[
                    {
                      required: true,
                      message: "Please Enter Mobile Number!",
                    },
                  ]}
                >
                  <Input
                    className="w-full"
                    maxLength={15}
                    onKeyPress={handleKeyPress}
                    placeholder="Mobile Number"
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} md={8} lg={6} xl={12}>
                <Form.Item
                  // label={
                  //   <span>
                  //     Email ID
                  //     <span style={{ color: "#FF000F" }}> *</span>
                  //   </span>
                  // }
                  name="email"
                  rules={[
                    {
                      required: true,
                      message: "Please Enter Email ID!",
                    },
                  ]}
                >
                  <Input className="w-full" placeholder="Email ID" />
                </Form.Item>
              </Col>
            </Row>
            <div className="font-sans font-semibold">Address Details</div>
            <Row gutter={20} className="mt-4">
              <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                <Form.Item
                  // label={
                  //   <span>
                  //     Address 1<span style={{ color: "#FF000F" }}> *</span>
                  //   </span>
                  // }
                  name="address1"
                  rules={[
                    {
                      required: true,
                      message: "Please Enter contact address!",
                    },
                  ]}
                >
                  <TextArea
                    autoSize={{
                      minRows: 1,
                      maxRows: 1,
                    }}
                    placeholder=" Address 1"
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                <Form.Item
                  // label="Address 2"
                  name="address2"
                >
                  <TextArea
                    autoSize={{
                      minRows: 1,
                      maxRows: 1,
                    }}
                    placeholder=" Address 2"
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={20}>
              <Col xs={24} sm={12} md={8} lg={6} xl={12}>
                <Form.Item
                  // label={
                  //   <span>
                  //     City
                  //     <span style={{ color: "#FF000F" }}> *</span>
                  //   </span>
                  // }
                  name="city"
                  rules={[
                    {
                      required: true,
                      message: "Please Enter City",
                    },
                  ]}
                >
                  <Input className="w-full" placeholder=" City" />
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} md={8} lg={6} xl={12}>
                <Form.Item
                  // label={<span>Pincode</span>}
                  name="pinCode"
                  rules={[
                    {
                      required: true,
                      message: "Please Enter Pincode",
                    },
                  ]}
                >
                  <Input
                    className="w-full"
                    maxLength={6}
                    onKeyPress={handleKeyPress}
                    placeholder="Pincode"
                  />
                </Form.Item>
              </Col>

              <Col xs={24} sm={12} md={8} lg={6} xl={12}>
                <Form.Item
                  // label={
                  //   <span>
                  //     State
                  //     <span style={{ color: "#FF000F" }}> *</span>
                  //   </span>
                  // }
                  name="state"
                  rules={[
                    {
                      required: true,
                      message: "Please Enter State",
                    },
                  ]}
                >
                  <Select
                    placeholder="State"
                    showSearch
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                      option.children
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                  >
                    {states?.map((state) => (
                      <Select.Option key={state.stateId} value={state.stateId}>
                        {state.stateName}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} md={8} lg={6} xl={12}>
                <Form.Item name="country">
                  <Select
                    placeholder="Country"
                    showSearch
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                      option.children
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                  >
                    {countries?.map((country) => (
                      <Select.Option
                        key={country.country_Id}
                        value={country.country_Id}
                      >
                        {country.country_Name}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>
            <Form.Item>
              <div className="flex justify-end  border-brand-colorBorder gap-3 pt-2">
                <button
                  className="border rounded-lg bg-white text-sm w-40"
                  onClick={patientCancel}
                >
                  Cancel
                </button>
                <button
                  className="bg-brand-primaryColor border rounded-lg  w-40 p-2 text-sm text-white"
                  type="primary"
                  htmlType="submit"
                  disabled={isButtonDisabled}
                >
                  Save
                </button>
              </div>
            </Form.Item>
          </div>
        </Row>
              
      </Form>
    </>
  );
}

export default NewPatientRegister;
